export const data2 = [
  [
    '113223,1',
    '1362,2',
    '1723,5',
    '1877,5',
    '2017,1',
    '2098,1',
    '2182,4',
    '2226,1'
  ],

  ['7,6%', '7,4%', '27,5%', '8,9%', '7,4%', '4,0%', '5,0%', '222,0%'],

  ['328,7', '234,0', '272,7', '328,7', '3112283,5', '398,9', '406,5', '502,9'],

  [
    '17,2%',
    '111227,2%',
    '15,8%',
    '17,8%',
    '111228,3%',
    '18,3%',
    '111228,3%',
    '18,3%'
  ],

  [
    '(18,8)',
    '(18,6)',
    '(13,7)',
    '(33,7)',
    '(32,8)',
    '(28,3)',
    '(23,5)',
    '(18,6)'
  ],

  ['7,6%', '7,6%', '27,5%', '8,9%', '7,4%', '4%', '5%', '2%'],

  ['(40,8%)', '(23%)', '27,7%', '28,7%', '28,0%', '28,5%', '23,5%', '18,5%'],

  ['107,0', '129,8', '138,2', '156,7', '208,7', '249,0', '266,0', '283,5'],

  [
    '(38,2)',
    '(43,9)',
    '(43,9)',
    '(75,8)',
    '(43,9)',
    '(75,8)',
    '(75,8)',
    '(75,8)'
  ],

  [
    '1122100,4',
    '113,8',
    '113,2',
    '156,7',
    '2112208,7',
    '249,0',
    '2112203,2',
    '2112211,5'
  ]
];

export const data = [
  [
    '1133,1',
    '1362,2',
    '1723,5',
    '1877,5',
    '2017,1',
    '2098,1',
    '2182,4',
    '2226,1'
  ],

  ['7,6%', '7,4%', '27,5%', '8,9%', '7,4%', '4,7%', '5,1%', '2,3%'],

  ['328,7', '234,0', '272,7', '328,7', '383,5', '398,9', '406,5', '502,9'],

  ['17,2%', '17,2%', '15,8%', '17,8%', '18,3%', '18,3%', '18,3%', '18,3%'],

  [
    '(18,8)',
    '(18,6)',
    '(13,7)',
    '(33,7)',
    '(32,8)',
    '(28,3)',
    '(23,5)',
    '(18,6)'
  ],

  ['7,6%', '7,6%', '27,5%', '8,9%', '7,4%', '4%', '5%', '2%'],

  ['(40,8%)', '(23%)', '27,7%', '28,7%', '28,0%', '28,5%', '23,5%', '18,5%'],

  ['107,0', '129,8', '138,2', '156,7', '208,7', '249,0', '266,0', '283,5'],

  [
    '(38,2)',
    '(43,9)',
    '(43,9)',
    '(75,8)',
    '(43,9)',
    '(75,8)',
    '(75,8)',
    '(75,8)'
  ],

  ['100,4', '113,8', '113,2', '156,7', '208,7', '249,0', '203,2', '211,5']
];

export const data3 = [
  ['21,6x', '18,6x', '16,8x'],
  ['20,0x', '18,5x', '17,0x'],
  ['18,9x', '17,5x', '16,5x'],
  ['16,5x', '16,1x', '14,6x']
];

export const MEASUREMENTS1 = [
  'PEER',
  'COUNTRY',
  'CURRENCY',
  'MARKET CAP.',
  'EV'
];

export const MEASUREMENTS2 = ['EV/Revenue', 'EV / EBITDA', 'EV / EBITA', 'PE'];

export const YEARS = [
  ['19-22', '19-21', '20-22'],
  ['2020', '2021', '2022']
];

export const MEASUREMENTS_PEER_OP_METRICS1 = [
  'REVENUE CAGR',
  'REVENUE/GROWTH',
  'GROSS MARGIN',
  'EBITDA MARGIN',
  'EBITA MARGIN'
];

export const MEASUREMENTS_PEER_OP_METRICS2 = [
  'NOPAT MARGIN',
  'CAPEX/REVENUE',
  'WRC/REVENUE',
  'NET DEBT/EBITDA',
  'Unlevered FCF/EBITDA'
];

/// ////////////////////// JD //////////////////////////

// Tableau peer operating metrics

// En %
export const REVENUE_CAGR_A = [
  ['10.8%', '2.6%', '40.8%'],
  ['10.8%', '13.5%', '34.5%'],
  ['10.8%', '8.1%', '37.7%'],
  ['10.8%', '8.1%', '37.7%'],
  ['73.8%', '87.1%', '62.0%']
];

export const REVENUE_CAGR_B = [
  ['10.8%', '2.6%', '40.8%'],
  ['17.6%', '13.5%', '34.5%'],
  ['14.2%', '8.1%', '37.7%'],
  ['14.2%', '8.1%', '37.7%'],
  ['73.8%', '87.1%', '62.0%']
];

export const REVENUE_GROWTH_A = [
  ['-31.5%', '53.5%', '29.1%'],
  ['-10.0%', '43.2%', '26.3%'],
  ['-20.8%', '48.4%', '27.7%'],
  ['-20.8%', '48.4%', '27.7%'],
  ['100.0%', '75.0%', '50.0%']
];

export const REVENUE_GROWTH_B = [
  ['-31.5%', '53.5%', '29.1%'],
  ['-10.0%', '43.2%', '26.3%'],
  ['-20.8%', '48.4%', '27.7%'],
  ['-20.8%', '48.4%', '27.7%'],
  ['100.0%', '75.0%', '50.0%']
];

export const GROSS_MARGIN_A = [
  ['39.8%', '39.8%', '39.8%'],
  ['32.8%', '32.8%', '32.8%'],
  ['36.3%', '36.3%', '36.3%'],
  ['36.3%', '36.3%', '36.3%'],
  ['35.0%', '35.0%', '35.0%']
];

export const GROSS_MARGIN_B = [
  ['39.8%', '39.8%', '39.8%'],
  ['32.8%', '32.8%', '32.8%'],
  ['36.3%', '36.3%', '36.3%'],
  ['36.3%', '36.3%', '36.3%'],
  ['35.0%', '35.0%', '35.0%']
];

export const EBITDA_MARGIN_A = [
  ['-39.0%', '-10.6%', '3.3%'],
  ['-19.7%', '-1.6%', '4.9%'],
  ['-29.4%', '-6.1%', '4.1%'],
  ['-29.4%', '-6.1%', '4.1%'],
  ['-100.0%', '-50.0%', '-25.0%']
];

export const EBITDA_MARGIN_B = [
  ['-39.0%', '-10.6%', '3.3%'],
  ['-19.7%', '-1.6%', '4.9%'],
  ['-29.4%', '-6.1%', '4.1%'],
  ['-29.4%', '-6.1%', '4.1%'],
  ['-120.0%', '-80.0%', '-40.0%']
];

export const EBITA_MARGIN_A = [
  ['-41.0%', '-12.6%', '1.2%'],
  ['-23.4%', '-4.5%', '2.3%'],
  ['-32.2%', '-8.6%', '1.8%'],
  ['-32.2%', '-8.6%', '1.8%'],
  ['-103.0%', '-52.0%', '-27.0%']
];

export const EBITA_MARGIN_B = [
  ['-41.0%', '-12.6%', '1.2%'],
  ['-23.4%', '-4.5%', '2.3%'],
  ['-32.2%', '-8.6%', '1.8%'],
  ['-32.2%', '-8.6%', '1.8%'],
  ['-123.0%', '-82.0%', '-42.0%']
];

export const NOPAT_MARGIN_A = [
  ['-41.0%', '-12.6%', '1.2%'],
  ['-23.4%', '-4.5%', '2.3%'],
  ['-32.2%', '-8.6%', '1.8%'],
  ['-32.2%', '-8.6%', '1.8%'],
  ['-103.0%', '-52.0%', '-27.0%']
];

export const NOPAT_MARGIN_B = [
  ['-41.0%', '-12.6%', '1.2%'],
  ['-23.4%', '-4.5%', '2.3%'],
  ['-32.2%', '-8.6%', '1.8%'],
  ['-32.2%', '-8.6%', '1.8%'],
  ['-123.0%', '-82.0%', '-42.0%']
];

export const CAPEX_REVENUE_A = [
  ['-5.0%', '-6.2%', '-6.3%'],
  ['-4.8%', '-3.8%', '-3.5%'],
  ['-4.9%', '-5.0%', '-4.9%'],
  ['-4.9%', '-5.0%', '-4.9%'],
  ['-5.0%', '-5.0%', '-5.0%']
];

export const CAPEX_REVENUE_B = [
  ['-5.0%', '-6.2%', '-6.3%'],
  ['-4.8%', '-3.8%', '-3.5%'],
  ['-4.9%', '-5.0%', '-4.9%'],
  ['-4.9%', '-5.0%', '-4.9%'],
  ['-5.0%', '-5.0%', '-5.0%']
];

export const WRC_REVENUE_A = [
  ['20.7%', '15.5%', '12.7%'],
  ['5.0%', '4.0%', '4.0%'],
  ['12.9%', '9.8%', '8.4%'],
  ['12.9%', '9.8%', '8.4%'],
  ['21.0%', '17.0%', '16.3%']
];

export const WRC_REVENUE_B = [
  ['20.7%', '15.5%', '12.7%'],
  ['5.0%', '4.0%', '4.0%'],
  ['12.9%', '9.8%', '8.4%'],
  ['12.9%', '9.8%', '8.4%'],
  ['21.0%', '17.0%', '16.3%']
];

export const NETDEBT_EBITDA_A = [
  ['0.4x', '(0.3x)', '1.0x'],
  ['0.1x', '(4.6x)', '1.6x'],
  ['0.2x', '(2.4x)', '1.3x'],
  ['0.2x', '(2.4x)', '1.3x'],
  ['(0.9x)', '(2.1x)', '(3.9x)']
];

export const NETDEBT_EBITDA_B = [
  ['0.4x', '(0.3x)', '1.0x'],
  ['0.1x', '(4.6x)', '1.6x'],
  ['0.2x', '(2.4x)', '1.3x'],
  ['0.2x', '(2.4x)', '1.3x'],
  ['(0.9x)', '(1.8x)', '(3.5x)']
];

export const UNLEVEREDFCF_EBITDA_A = [
  ['100.1%', '139.4%', '-72.8%'],
  ['98.9%', '85.3%', '111.0%'],
  ['99.5%', '112.4%', '19.1%'],
  ['99.5%', '112.4%', '19.1%'],
  ['100.2%', '100.9%', '101.8%']
];

export const UNLEVEREDFCF_EBITDA_B = [
  ['100.1%', '139.4%', '-72.8%'],
  ['98.9%', '85.3%', '111.0%'],
  ['99.5%', '112.4%', '19.1%'],
  ['99.5%', '112.4%', '19.1%'],
  ['100.2%', '100.7%', '101.5%']
];

// Tableau valuation

export const COUNTRY_CURRENCY_MKTCAP_EV_A = [
  ['US', 'USD', '8,897', '5,585'],
  ['US', 'USD', '52,561', '44,831']
];

export const COUNTRY_CURRENCY_MKTCAP_EV_B = [
  ['US', 'USD', '8,897', '5,585'],
  ['US', 'USD', '52,561', '44,831']
];
export const EV_REVENU_A = [
  ['2.6x', '1.8x', '1.4x'],
  ['3.5x', '2.5x', '2.0x'],
  ['3.1x', '2.2x', '1.7x'],
  ['3.1x', '2.2x', '1.7x']
];

export const EV_REVENU_B = [
  ['2.6x', '1.8x', '1.4x'],
  ['3.5x', '2.5x', '2.0x'],
  ['3.1x', '2.2x', '1.7x'],
  ['3.1x', '2.2x', '1.7x']
];

export const EV_REVENU_A_LOW_HIGH_END_A = [
  ['2.4x', '1.9x', '1.5x'],
  ['3.6x', '2.6x', '2.0x']
];

export const EV_REVENU_A_LOW_HIGH_END_B = [
  ['2.6x', '2.3x', '2.0x'],
  ['3.8x', '3.0x', '2.4x']
];

export const EV_EBITDA_A = [
  ['(6.7x)', '(17.4x)', '44.5x'],
  ['(17.6x)', '(158.8x)', '41.0x'],
  ['(12.2x)', '(88.1x)', '42.8x'],
  ['(12.2x)', '(88.1x)', '42.8x']
];

export const EV_EBITDA_B = [
  ['(6.7x)', '(17.4x)', '44.5x'],
  ['(17.6x)', '(158.8x)', '41.0x'],
  ['(12.2x)', '(88.1x)', '42.8x'],
  ['(12.2x)', '(88.1x)', '42.8x']
];

export const EV_EBITDA_A_LOW_HIGH_A = [
  ['(2.4x)', '(3.8x)', '(6.2x)'],
  ['(3.6x)', '(5.2x)', '(8.0x)']
];

export const EV_EBITDA_A_LOW_HIGH_B = [
  ['(2.2x)', '(2.9x)', '(4.9x)'],
  ['(3.2x)', '(3.8x)', '(6.1x)']
];

export const EV_EBITA_A = [
  ['(6.4x)', '(14.6x)', '120.2x'],
  ['(14.8x)', '(55.9x)', '88.4x'],
  ['(10.6x)', '(35.3x)', '104.3x'],
  ['(10.6x)', '(35.3x)', '104.3x']
];

export const EV_EBITA_B = [
  ['(6.4x)', '(14.6x)', '120.2x'],
  ['(14.8x)', '(55.9x)', '88.4x'],
  ['(10.6x)', '(35.3x)', '104.3x'],
  ['(10.6x)', '(35.3x)', '104.3x']
];

export const EV_EBITA_LOW_HIGH_A = [
  ['(2.3x)', '(3.7x)', '(5.7x)'],
  ['(3.5x)', '(5.0x)', '(7.4x)']
];

export const EV_EBITA_LOW_HIGH_B = [
  ['(2.1x)', '(2.8x)', '(4.7x)'],
  ['(3.1x)', '(3.7x)', '(5.8x)']
];

export const PE_A = [
  ['(9.1x)', '(21.6x)', '61.1x'],
  ['(14.3x)', '(25.6x)', '(44.1x)'],
  ['(11.7x)', '(23.6x)', '8.5x'],
  ['(11.7x)', '(23.6x)', '8.5x']
];

export const PE_B = [
  ['(9.1x)', '(21.6x)', '61.1x'],
  ['(14.3x)', '(25.6x)', '(44.1x)'],
  ['(11.7x)', '(23.6x)', '8.5x'],
  ['(11.7x)', '(23.6x)', '8.5x']
];

export const PE_LOW_HIGH_A = [
  ['(1.5x)', '(1.7x)', '(2.1x)'],
  ['(2.7x)', '(3.0x)', '(3.7x)']
];

export const PE_LOW_HIGH_B = [
  ['(1.3x)', '(1.1x)', '(1.4x)'],
  ['(2.3x)', '(1.9x)', '(2.4x)']
];

/// FINANCIAL MODELING ///

export const INCOME_STATEMENT_A = [
  ['250.0', ' 500.0', '875.0', '1,312.5', '1,640.6', '1,886.7'],
  ['', '100.0', '75.0', '50.0', '25.0', '15.0'],
  ['87.5', '175.0', '306.3', '459.4', '574.2', '660.4'],
  ['35.0', '35.0', '35.0', '35.0', '35.0', '35.0'],
  ['-450.0', '-500.0', '-437.5', ' -328.1', '-82.0', '18.9'],
  ['-180.0', '-100.0', '-50.0', '-25.0', '-5.0', '1.0'],
  ['(5.0)', '(15.0)', '(17.5)', '(26.3)', '(32.8)', '(37.7)'],
  ['-2.0', '-3.8', '-3.6', '-3.4', '-3.4', '-3.4'],
  ['(10.0)', '(12.0)', '(8.0)', '(11.0)', '(13.8)', '(15.8)'],
  ['-465.0', '-527.0', '-463.0', '-365.4', '-128.6', '-34.6'],
  ['-186.0', '-105.4', '-52.9', '-27.8', '-7.8', '-1.8'],
  ['0.0', '(5.8)', '(18.1)', '(28.9)', '(35.4)', '(37.5)'],
  ['0.0', '(6.3)', '(18.8)', '(30.0)', '(36.9)', '(39.3)'],
  ['0.0', '2.5', '2.5', '2.5', '2.5', '2.5'],
  ['0.0', '0.5', '0.7', '1.1', '1.5', '1.8'],
  ['-465.0', '-532.8', '-481.1', '-394.3', '-164.0', '-72.1'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['0', '0', '0', '0', '0', '0'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['-465.0', '-532.8', '-481.1', '-394.3', '-164.0', '-72.1']
];

export const INCOME_STATEMENT_B = [
  ['250.0', '500.0', '875.0', '1,312.5', '1,640.6', '1,886.7'],
  ['', '100.0', '75.0', '50.0', '25.0', '15.0'],
  ['87.5', '175.0', '306.3', '459.4', '574.2', '660.4'],
  ['35.0', '35.0', '35.0', '35.0', '35.0', '35.0'],
  ['-450.0', '-600.0', '-700.0', '-525.0', '-246.1', '-18.9'],
  ['-180.0', '-120.0', '-80.0', '-40.0', '-15.0', '-1.0'],
  ['(5.0)', '(15.0)', '(17.5)', '(26.3)', '(32.8)', '(37.7)'],
  ['-2.0', '-3.8', '-3.6', '-3.4', '-3.4', '-3.4'],
  ['(10.0)', '(12.0)', '(8.0)', '(11.0)', '(13.8)', '(15.8)'],
  ['-465.0', '-627.0', '-725.5', '-562.3', '-292.7', '-72.4'],
  ['-186.0', '-125.4', '-82.9', '-42.8', '-17.8', '-3.8'],
  ['0.0', '(7.1)', '(24.0)', '(40.7)', '(52.1)', '(57.2)'],
  ['0.0', '(7.6)', '(24.7)', '(41.8)', '(53.6)', '(59.0)'],
  ['0.0', '2.5', '2.5', '2.5', '2.5', '2.5'],
  ['0.0', '0.5', '0.7', '1.1', '1.5', '1.8'],
  ['-465.0', '-634.1', '-749.5', '-603.0', '-344.8', '-129.6'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['0', '0', '0', '0', '0', '0'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['-465.0', '-634.1', '-749.5', '-603.0', '-344.8', '-129.6']
];

export const CASH_FLOW_A = [
  ['-465.0', '-532.8', '-481.1', '-394.3', '-164.0', '-72.1'],
  ['15.0', '27.0', '25.5', '37.3', '46.6', '53.5'],
  ['5.0', '15.0', '17.5', '26.3', '32.8', '37.7'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['(450.0)', '(505.8)', '(455.6)', '(357.0)', '(117.4)', '(18.6)'],
  ['3.0', '25.0', '43.8', '65.6', '82.0', '94.3'],
  ['5.5', '5.0', '5.0', '5.0', '5.0', '5.0'],
  ['-436.2', '-480.8', '-411.8', '-291.4', '-35.4', '75.7'],
  ['(12.0)', '(25.0)', '(43.8)', '(65.6)', '(82.0)', '(94.3)'],
  ['-4.8', '-5.0', '-5.0', '-5.0', '-5.0', '-5.0'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['-12.0', '-25.0', '-43.7', '-65.6', '-82.0', '-94.3'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['0.0', '505.8', '493.1', '400.8', '150.2', '43.3'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['0.0', '505.8', '493.1', '400.8', '150.2', '43.3'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['-448.2', '0.0', '37.6', '43.8', '32.7', '24.6'],
  ['498.2', '50.0', '50.0', '87.6', '131.3', '164.0'],
  ['50.0', '50.0', '87.6', '131.3', '164.0', '188.7']
];

export const CASH_FLOW_B = [
  ['-465.0', '-634.1', '-749.5', '-603.0', '-344.8', '-129.6'],
  ['15.0', '27.0', '25.5', '37.3', '46.6', '53.5'],
  ['5.0', '15.0', '17.5', '26.3', '32.8', '37.7'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['(450.0)', '(607.1)', '(724.0)', '(565.7)', '(298.2)', '(76.1)'],
  ['3.0', '25.0', '43.8', '65.6', '82.0', '94.3'],
  ['5.5', '5.0', '5.0', '5.0', '5.0', '5.0'],
  ['-436.2', '-582.1', '-680.2', '-500.1', '-216.2', '18.2'],
  ['(12.0)', '(25.0)', '(43.8)', '(65.6)', '(82.0)', '(94.3)'],
  ['-4.8', '-5.0', '-5.0', '-5.0', '-5.0', '-5.0'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['-12.0', '-25.0', '-43.7', '-65.6', '-82.0', '-94.3'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['0.0', '607.1', '761.5', '609.5', '331.0', '100.7'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['0.0', '607.1', '761.5', '609.5', '331.0', '100.7'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['-448.2', '0.0', '37.6', '43.8', '32.8', '24.6'],
  ['498.2', '50.0', '50.0', '87.6', '131.3', '164.1'],
  ['50.0', '50.0', '87.6', '131.3', '164.1', '188.7']
];

export const BALANCE_SHEET_A = [
  ['265.0', '265.0', '265.0', '265.0', '265.0', '265.0'],
  ['110.0', '120.0', '146.3', '185.6', '234.8', '291.4'],
  ['(80.0)', '(105.0)', '(148.8)', '(214.4)', '(296.4)', '(390.7)'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['295.0', '280.0', '262.5', '236.2', '203.4', '165.7'],
  ['395.0', '(125.8)', '(598.9)', '(982.2)', '(1,132.4)', '(1,188.8)'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['(50.0)', '455.8', '911.4', '1,268.0', '1,385.9', '1,404.5'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['(50.0)', '(50.0)', '(50.0)', '(50.0)', '(50.0)', '(50.0)'],
  ['295.0', '280.0', '262.5', '236.2', '203.4', '165.7'],
  ['50.0', '50.0', '87.6', '131.3', '164.1', '188.7'],
  ['0.0', '505.8', '998.9', '1,399.7', '1,549.9', '1,593.2'],
  ['-50.0', '455.8', '911.3', '1,268.4', '1,385.8', '1,404.5'],
  ['110.0', '120.0', '146.3', '185.6', '234.8', '291.4'],
  ['265.0', '265.0', '265.0', '265.0', '265.0', '265.0'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['(80.0)', '(105.0)', '(148.8)', '(214.4)', '(296.4)', '(390.7)'],
  ['295.0', '280.0', '262.5', '236.2', '203.4', '165.7'],
  ['(265.0)', '(265.0)', '(265.0)', '(265.0)', '(265.0)', '(265.0)'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['30.0', '15.0', '-2.5', '-28.8', '-61.6', '-99.3']
];

export const BALANCE_SHEET_B = [
  ['265.0', '265.0', '265.0', '265.0', '265.0', '265.0'],
  ['110.0', '120.0', '146.3', '185.6', '234.8', '291.4'],
  ['(80.0)', '(105.0)', '(148.8)', '(214.4)', '(296.4)', '(390.7)'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['295.0', '280.0', '262.5', '236.2', '203.4', '165.7'],
  [],
  ['395.0', '(277.7)', '(968.6)', '(1,560.6)', '(1,891.6)', '(2,005.4)'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['(50.0)', '557.1', '1,281.1', '1,846.8', '2,145.0', '2,221.1'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['(50.0)', '(50.0)', '(50.0)', '(50.0)', '(50.0)', '(50.0)'],
  ['295.0', '280.0', '262.5', '236.2', '203.4', '165.7'],
  ['50.0', '50.0', '87.6', '131.3', '164.1', '188.7'],
  ['0.0', '657.7', '1,597.7', '2,345.9', '2,852.4', '3,043.3'],
  ['-50.0', '607.7', '1,510.1', '2,214.6', '2,688.3', '2,854.6'],
  [],
  ['110.0', '120.0', '146.3', '185.6', '234.8', '291.4'],
  ['265.0', '265.0', '265.0', '265.0', '265.0', '265.0'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['(80.0)', '(105.0)', '(148.8)', '(214.4)', '(296.4)', '(390.7)'],
  ['295.0', '280.0', '262.5', '236.2', '203.4', '165.7'],
  ['(265.0)', '(265.0)', '(265.0)', '(265.0)', '(265.0)', '(265.0)'],
  ['0.0', '0.0', '0.0', '0.0', '0.0', '0.0'],
  ['30.0', '15.0', '-2.5', '-28.8', '-61.6', '-99.3']
];

// Analytic Ratios

export const GROWTH_PROFITABILITY_ANALYSIS_A = [
  ['NA', '100.0', '75.0', '50.0', '25.0', '15.0'],
  ['NA', 'neg/neg', 'neg/neg', 'neg/neg', 'neg/neg', 'neg/neg'],
  ['NA', 'neg/neg', 'neg/neg', 'neg/neg', 'neg/neg', 'neg/neg'],
  ['NA', 'neg/neg', 'neg/neg', 'neg/neg', 'neg/neg', 'neg/neg'],
  [],
  [],
  [],
  [],
  [],
  [],
  ['-180.0', '-100.0', '-50.0', '-25.0', '-5.0', '1.0']
];

export const GROWTH_PROFITABILITY_ANALYSIS_B = [
  ['NA', '100.0', '75.0', '50.0', '25.0', '15.0'],
  ['NA', 'neg/neg', 'neg/neg', 'neg/neg', 'neg/neg', 'neg/neg'],
  ['NA', 'neg/neg', 'neg/neg', 'neg/neg', 'neg/neg', 'neg/neg'],
  ['NA', 'neg/neg', 'neg/neg', 'neg/neg', 'neg/neg', 'neg/neg'],
  [],
  [],
  [],
  [],
  [],
  [],
  ['-180.0', '-120.0', '-80.0', '-40.0', '-15.0', '-1.0']
];

export const CREDIT_RATIOS_A = [
  ['96.4', '96.0', '98.4', '97.7', '91.3', '53.9'],
  ['99.6', '101.2', '104.1', '108.8', '143.2', '-98.9'],
  [],
  ['0.1x', '-0.9x', '-2.1x', '-3.9x', '-16.9x', '74.4x'],
  ['0.1x', '-0.9x', '-1.9x', '-3.2x', '-8.4x', '-18.6x'],
  ['0.0x', '79.4x', '23.3x', '10.9x', '2.2x', '-0.5x'],
  ['0.0x', '0.0x', '0.0x', '0.0x', '0.0x', '0.0x']
];

export const CREDIT_RATIOS_B = [
  ['96.4', '96.8', '99.8', '100.6', '101.9', '105.2'],
  ['99.6', '101.2', '103.4', '107.8', '121.2', '403.4'],
  [],
  ['0.1x', '-0.9x', '-1.8x', '-3.5x', '-8.7x', '-117.7x'],
  ['0.1x', '-0.9x', '-1.7x', '-3.1x', '-6.5x', '-19.6x'],
  ['0.0x', '78.9x', '28.3x', '12.6x', '4.6x', '0.3x'],
  ['0.0x', '0.0x', '0.0x', '0.0x', '0.0x', '0.0x']
];

export const LEVERAGE_RETURN_ON_CAPITAL_A = [
  ['(12.7)', '(362.3)', '(152.2)', '(129.1)', '(122.4)', '(118.1)'],
  ['(14.5)', '138.1', '291.6', '443.7', '546.7', '651.1'],
  ['(157.6)', '(188.2)', '(176.4)', '(154.7)', '(63.2)', '(20.9)'],
  ['(151.9)', '(180.6)', '(173.5)', '(151.2)', '(57.7)', '(11.3)'],
  ['(117.7)', '423.5', '80.3', '40.1', '14.5', '6.1']
];

export const LEVERAGE_RETURN_ON_CAPITAL_B = [
  ['(12.7)', '(200.6)', '(132.3)', '(118.3)', '(113.4)', '(110.8)'],
  ['(14.5)', '199.4', '410.0', '645.3', '846.5', '1029.7'],
  ['(157.6)', '(223.9)', '(276.4)', '(238.1)', '(143.9)', '(43.7)'],
  ['(151.9)', '(216.8)', '(275.8)', '(239.5)', '(146.6)', '(45.9)'],
  ['(117.7)', '228.3', '77.4', '38.6', '18.2', '6.5']
];

/// / Recent comparable transaction

export const RECENT_COMPARABLE_TRANSACTION = [
  ('Grab', 'Aug-2020', '200M$'),
  ('Gett', 'Jul-2020', '100M$'),
  ('Superpedestrian', 'June-2020', '55M$'),
  ('TIER Mobility', 'June-2020', '122M$'),
  ('Lime', 'June-2020', '170M$'),
  ('Bolt', 'May-2020', '109M$'),
  ('Waymo', 'May-2020', '3,000M$'),
  ('Getaround', 'April-2020', '63M$'),
  ('Via', 'March-2020', '200M$')
];

export const COMPANIES = ['Lyft', 'Uber Technologies'];

export const years2 = [2020, 2021, 2022];
